import { PacketMetaDataType } from './model/dmpPacket';
import {
  PacketRecordResultModel,
  PledgeRecordResultModel,
  PositionRecordResultModel,
  SaleRecordResultModel,
  PacketItemModel,
} from './model/dmpPosition';
import { AcfType, DividedRuleType, DroDetailType } from './model/dro';
import { DmpDateTypeEnum } from '/@/enums/dmpEnum';
import { defHttp } from '/@/utils/http/axios';

enum Api {
  //持仓记录列表
  positionList = '/analysis/dmp/balance/search',
  // 导出持仓记录
  exportPosition = '/analysis/dmp/balance/search-export',
  // 质押记录列表
  pledgeList = '/analysis/dmp/pledge/search',
  // 导出质押记录
  exportPledge = '/analysis/dmp/pledge/search-export',
  // 出售记录列表
  saleList = '/analysis/dmp/sell/search',
  // 导出出售记录
  exportSale = '/analysis/dmp/sell/search-export',
  // 封包记录列表
  packetList = '/analysis/dmp/packet/search',
  // 确认封包
  confirmPacket = '/analysis/dmp/packet/confirm',
  // 解封包
  unsealPacket = '/analysis/dmp/packet/unpack',
  // 导出封包
  exportPacket = '/analysis/dmp/packet/export',
  // 资金流水列表
  financeList = '/analysis/dmp/cash-flow/search',
  // 导出资金流水
  exportFinance = '/analysis/dmp/cash-flow/search-export',
  // 搜索并全选，返回itemIds
  packetItemIds = '/analysis/dmp/packet/all',
  /**
   * 筛选项
   */
  // dro状态
  droStatusOptions = '/analysis/dmp/dro-status-option',
  // 质权人
  beneficiaryOptions = '/analysis/dmp/pledge/beneficiary-option',
  // 质权人账号
  beneficiaryAccountOptions = '/analysis/dmp/pledge/beneficiary-account-option',
  // 出售人
  purchaserOptions = '/analysis/dmp/sell/purchaser-option',
  // 出售人账号
  purchaserAccountOptions = '/analysis/dmp/sell/purchaser-account-option',
  // 交易类型
  transactionTypeOptions = '/analysis/dmp/cash-flow/transaction-type-option',

  /**
   * 通用信息
   */
  // 数据更新时间
  dataUpdateTime = '/analysis/dmp/latest-time',
  // 封包元数据
  packetMetadata = '/analysis/dmp/packet/metadata',

  // dro详情-专业投资者
  droInfo = '/analysis/dro/pro/detail',
  // Dro详情-专业投资者-acf走势图
  droAcf = '/analysis/dro/pro/acf',
  // dro详情-专业投资者-acf走势图导出
  droAcfExport = '/analysis/dro/pro/acf-export',
  // dro详情-专业投资者-指标走势
  droDetailMetric = '/analysis/dro/pro/detail-metric',
  // dro详情-专业投资者-分成规则
  droDividedRule = '/analysis/dro/pro/divided-rule',
}
/**
 * 接口 [搜索持仓记录列表](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/searchBalance_1)
 * @returns
 * */
export const dmpSearchPositionList = (params) =>
  defHttp.get<PositionRecordResultModel>({
    url: Api.positionList,
    params,
  });
/**
 * 接口 [导出持仓记录列表](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/searchBalanceExport_1)
 */
export const dmpExportPositionList = (params) =>
  defHttp.get(
    {
      url: Api.exportPosition,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
    },
  );
/**
 * 接口 [搜索质押记录列表](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/searchPledge)
 */
export const dmpSearchPledgeList = (params) =>
  defHttp.get<PledgeRecordResultModel>({
    url: Api.pledgeList,
    params,
  });
/**
 * 接口 [导出质押记录列表](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/searchPledgeExport)
 */
export const dmpExportPledgeList = (params) =>
  defHttp.get(
    {
      url: Api.exportPledge,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
    },
  );

/**
 * 接口 [搜索出售记录列表](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/searchBalance)
 */
export const dmpSearchSaleList = (params) =>
  defHttp.get<SaleRecordResultModel>({
    url: Api.saleList,
    params,
  });
/**
 * 接口 [导出出售记录列表](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/searchBalanceExport)
 */
export const dmpExportSaleList = (params) =>
  defHttp.get(
    {
      url: Api.exportSale,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
    },
  );

/**
 * 接口 [搜索封包记录列表](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/%E5%B0%81%E5%8C%85%E8%AE%B0%E5%BD%95/searchPacket)
 */
export const dmpSearchPacketList = (params) =>
  defHttp.get<PacketRecordResultModel>({
    url: Api.packetList,
    params,
  });

/**
 * 接口 [搜索并全选，返回itemIds](https://exmt-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/%E5%B0%81%E5%8C%85%E8%AE%B0%E5%BD%95/listAllPacketItemIds)
 */
export const dmpListAllPacketItemIds = (params) =>
  defHttp.get<PacketItemModel[]>({
    url: Api.packetItemIds,
    params,
  });
/**
 * 接口 [获取dro状态筛选项](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/getDroStatusOption)
 */
export const dmpDroStatusOptionsApi = (params) =>
  defHttp.get<string[]>({
    url: Api.droStatusOptions,
    params,
  });
/**
 * 接口 [获取质权人筛选项](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/beneficiaryOption)
 */
export const dmpBeneficiaryOptionsApi = (params) =>
  defHttp.get<string[]>({
    url: Api.beneficiaryOptions,
    params,
  });
/**
 * 接口 [获取质权人账号筛选项](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/beneficiaryAccountOption)
 * @param params
 * @returns
 * */
export const dmpBeneficiaryAccountOptionsApi = (params) =>
  defHttp.get<string[]>({
    url: Api.beneficiaryAccountOptions,
    params,
  });
/**
 * 接口 [获取出售人筛选项](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/purchaserOption)
 * @param params
 * @returns
 * */
export const dmpPurchaserOptionsApi = (params) =>
  defHttp.get<string[]>({
    url: Api.purchaserOptions,
    params,
  });
/**
 * 接口 [获取出售人账号筛选项](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/purchaserAccountOption)
 * @param params
 * @returns
 * */
export const dmpPurchaserAccountOptionsApi = (params) =>
  defHttp.get<string[]>({
    url: Api.purchaserAccountOptions,
    params,
  });

/**
 * 接口 [获取数据更新时间](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/getDroStatusOption)
 */
export const dmpDataUpdateTimeApi = (params: { dataType: DmpDateTypeEnum }) =>
  defHttp.get<string>({
    url: Api.dataUpdateTime,
    params,
  });
/**
 * 接口 [获取封包元数据](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/%E5%B0%81%E5%8C%85%E8%AE%B0%E5%BD%95/getPacketMetaData)
 */
export const dmpPacketMetadataApi = (params) =>
  defHttp.get<PacketMetaDataType>({
    url: Api.packetMetadata,
    params,
  });
/**
 * 接口 [确认封包](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/%E5%B0%81%E5%8C%85%E8%AE%B0%E5%BD%95/confirmPacket)
 */
export const dmpConfirmPacketApi = (params: { packetCode: string; packetName: string }) =>
  defHttp.post({
    url: Api.confirmPacket,
    data: {
      packetCode: params.packetCode,
    },
    params,
  });
/**
 * 接口 [解封包](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/%E5%B0%81%E5%8C%85%E8%AE%B0%E5%BD%95/unpack)
 */
export const dmpUnsealPacketApi = (data: string[]) =>
  defHttp.post({
    url: Api.unsealPacket,
    data,
  });
/**
 * 接口 [导出封包](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/%E5%B0%81%E5%8C%85%E8%AE%B0%E5%BD%95/exportPacket)
 */
export const dmpExportPacketApi = (params) =>
  defHttp.get(
    {
      url: Api.exportPacket,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
    },
  );

/**
 * 接口 [搜索资金流水列表](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/searchCashFlow)
 */
export const dmpSearchFinanceList = (params) =>
  defHttp.get({
    url: Api.financeList,
    params,
  });
/**
 * 接口 [导出资金流水列表](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/searchCashFlowExport)
 */
export const dmpExportFinanceList = (params) =>
  defHttp.get(
    {
      url: Api.exportFinance,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
    },
  );
/**
 * 接口 [获取交易类型筛选项](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dmp%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/transActionType)
 */
export const dmpTransactionTypeOptionsApi = (params) =>
  defHttp.get<string[]>({
    url: Api.transactionTypeOptions,
    params,
  });

/**
 * 接口 [获取dro详情-专业投资者](https://exmt-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3-%E4%B8%93%E4%B8%9A%E6%8A%95%E8%B5%84%E8%80%85/getDroStatusOption)
 */
export const dmpDroInfoApi = (params: { droCode: string }) =>
  defHttp.get<DroDetailType>({
    url: Api.droInfo,
    params,
  });

/**
 * 接口 [acf走势图](https://exmt-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3-%E4%B8%93%E4%B8%9A%E6%8A%95%E8%B5%84%E8%80%85/getAcfList)
 */
export const dmpDroAcfApi = (params: { droCode: string }) =>
  defHttp.get<AcfType[]>({
    url: Api.droAcf,
    params,
  });

/**
 * 接口 [导出acf走势图](https://exmt-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/acfProExport)
 */
export const dmpDroAcfExportApi = (params: { droCode: string }) =>
  defHttp.get(
    {
      url: Api.droAcfExport,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
    },
  );
/**
 * 接口 [指标走势](https://exmt-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/getProMetric)
 */
export const dmpDroDetailMetricApi = (params: { droCode: string }) =>
  defHttp.get({
    url: Api.droDetailMetric,
    params,
  });
/*
 * 接口 [获取分成规则](https://exmt-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/getRules)
 */
export const dmpDroDividedRuleApi = (params: { droCode: string }) =>
  defHttp.get<DividedRuleType[]>({
    url: Api.droDividedRule,
    params,
  });
